/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import { action } from '@ember/object';
import { waitFor } from '@ember/test-waiters';
import { BookingSource } from 'uplisting-frontend/models/booking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AnalyticsEvents } from 'uplisting-frontend/services/analytics';
import { invalidAttributeDetail } from 'uplisting-frontend/utils/http';

interface IArgs {
  booking: ModelRegistry['booking'];
}

interface BookingSourceSelectorSignature {
  Element: null;

  Args: IArgs;
}

export default class UiBookingSourceSelectorComponent extends Component<BookingSourceSelectorSignature> {
  @service analytics!: Services['analytics'];
  @service notifications!: Services['notifications'];
  @service sentry!: Services['sentry'];

  sources = Object.values(BookingSource);

  @cached
  get booking(): ModelRegistry['booking'] {
    return this.args.booking;
  }

  @action
  @waitFor
  async handleSelect(source: BookingSource): Promise<void> {
    const { booking } = this;

    const previousSource = booking.source;

    booking.source = source;

    try {
      await booking.save();

      this.analytics.trackEvent(AnalyticsEvents.bookingSourceChanged);

      this.notifications.info(
        'action_bookings_summary.change_source.notifications.applied',
      );

      await booking.reload();
    } catch (error) {
      booking.source = previousSource;

      const detail = invalidAttributeDetail(error);

      if (detail) {
        this.notifications.error(detail, true);
      } else {
        this.sentry.captureException(error);
        this.notifications.error();
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::SourceSelector': typeof UiBookingSourceSelectorComponent;
  }
}
